import React from 'react';
import PropTypes from 'prop-types';
import { queryCollection } from 'iguazu-rest';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { connectAsync } from 'iguazu';
import { withRouter } from '@americanexpress/one-app-router';
import { withConditionalFeatures } from '@americanexpress/conditional-features';
import { getIsLoggedInSelector } from '@americanexpress/travel-selectors';
import { RenderModule } from 'holocron';
import { useIsCenturionContext } from '../../context/isCenturionContext';
import { hasUnusedCreditCTARule, hasUnusedCreditRule } from '../../constants/featureRulesConstants';
import { TERMS_MODULE_NAME } from '../../constants/modules';

const Terms = ({ unusedCredit, hasUnusedCreditCTA, showVacationRentals }) => {
  const isCenturion = useIsCenturionContext();
  const checkUnusedCredit = hasUnusedCreditCTA
    && Array.isArray(unusedCredit) && unusedCredit.length > 0
    ? ['eticket']
    : [];
  const termsAndConditionsToShow = [
    ...isCenturion ? ['centurion'] : ['homepage'],
    ...showVacationRentals ? ['star'] : [],
    ...checkUnusedCredit,
  ];

  return (
    <RenderModule
      moduleName={TERMS_MODULE_NAME}
      props={{ programs: termsAndConditionsToShow }}
    />
  );
};

Terms.propTypes = {
  unusedCredit: PropTypes.arrayOf(PropTypes.shape({})),
  hasUnusedCreditCTA: PropTypes.bool.isRequired,
  showVacationRentals: PropTypes.bool.isRequired,
};

Terms.defaultProps = {
  unusedCredit: [],
};

const mapStateToProps = createStructuredSelector({
  isLoggedIn: getIsLoggedInSelector,
});

const mapFeaturesToProps = {
  hasUnusedCredit: hasUnusedCreditRule,
  hasUnusedCreditCTA: hasUnusedCreditCTARule,
};

export const loadDataAsProps = ({
  store: { dispatch },
  ownProps: { hasUnusedCredit, isLoggedIn },
}) => ({
  ...isLoggedIn
  && hasUnusedCredit && {
    unusedCredit: () => dispatch(
      queryCollection({
        resource: 'unusedCredit',
        id: '',
      })
    ),
  },
});

const hocChain = compose(
  withConditionalFeatures({ mapFeaturesToProps }),
  connect(mapStateToProps),
  connectAsync({ loadDataAsProps }),
  withRouter
);

export { Terms as TestableTerms };

export default hocChain(Terms);
